import { useEffect } from "react";
import { isMfeEmbedded } from "../../utils/mfeElement";

/**
 * Prevents the page behind an overlay from scrolling while `locked` is true.
 * The current scroll position is preserved and restored on unlock. `position: fixed`
 * is used alongside `overflow: hidden` so the lock is honoured by iOS Safari.
 *
 * The lock is not applied when the component is rendered inside a standalone
 * MFE (booking-form/secure-your-booking), because the host page must keep its
 * own scroll behaviour.
 */
const useBodyScrollLock = (locked: boolean): void => {
  useEffect(() => {
    if (!locked || isMfeEmbedded()) return;

    const { body } = document;
    const scrollY = window.scrollY;
    const previous = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
    };

    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";

    return () => {
      body.style.overflow = previous.overflow;
      body.style.position = previous.position;
      body.style.top = previous.top;
      body.style.width = previous.width;
      window.scrollTo(0, scrollY);
    };
  }, [locked]);
};

export default useBodyScrollLock;
